
import {mapActions, mapGetters} from "vuex";
import _ from 'lodash'

export default {
    name: "select-category",
    data() {
        return {
            selectedCategory: {}
        }
    },
    watch: {
        '$route'(newVal) {

        }

    },
    created() {

        this.fetchCategories()
        if (this.$route.query) {
            this.selectedCategory = this.$route.query
        }
    },
    computed: {
        ...mapGetters({
            getList: `category/list`,
        })
    },
    methods: {
        ...mapActions({
            fetchList: 'category/GET_LIST_CATEGORY',
            fetchCategories: `category/GET_LIST`,
        }),
        toggleOverlay: function () {
            const overlay = document.querySelector('.overlay-category')
            overlay.classList.toggle('open')
        },
        toggleBurger: function () {
            const burgerDeluxe = document.getElementById('burger_deluxe2')
            burgerDeluxe.classList.toggle('open')
        },
        scrollTop: function () {
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        },
        selectFilter($event) {
            if ($event.target.name === 'group') {
                this.selectedCategory.seller = ''
            }


            for (let i in this.getList) {
                let category = this.getList[i]

                if (category.sellers !== undefined) {

                    category.sellers.forEach(seller => {
                        if (seller.slug === this.selectedCategory.seller) {
                            return this.selectedCategory.category = category.slug
                        }
                    })
                }
            }


            const params = _.assign({}, this.$route.query, this.selectedCategory)
            history.pushState(
                {},
                null,
                this.$route.path + '?' + Object.keys(params)
                    .map(key => {
                        return (
                            encodeURIComponent(key) + '=' + encodeURIComponent(params[key])
                        )
                    })
                    .join('&')
            )
            this.sendRequest();
        },
        sendRequest: _.debounce(function () {
            this.fetchList(this.$route.query);
        }, 300),
    }
}
